import { AgentRegister } from '../../models/agents/agent-register';
import { Authorizations } from '../../models/agents/authorizations';
import { BankData } from '../../models/agents/bank-data';
import { Beneficiary } from '../../models/agents/beneficiary';
import { CompanyData } from '../../models/agents/company-data';
import { ContractData } from '../../models/agents/contract-data';
import { Director } from '../../models/agents/director';
import { EconomicGroup } from '../../models/agents/economic-group';
import { Files } from '../../models/agents/files';
import { Invitation } from '../../models/agents/invitation.ts';
import { Partner } from '../../models/agents/partner';
import { PatrimonialSituation } from '../../models/agents/patrimonial';
import { Pix } from '../../models/agents/pix';
import { RegistrationHistory } from '../../models/agents/registration-history';
import { RelationshipContact } from '../../models/agents/relationship-contact';
import { RepresentativesData } from '../../models/agents/representatives-data';
import { SuitabilityScore } from '../../models/agents/suitability-score';
import { PersonType } from '../../models/enums/person-type.enum';
import { Question } from '../../models/suitability/question';
import { Suitability } from '../../models/suitability/suitability';

export class InitCompanyFromServer {
  readonly type = 'INIT_COMPANY_FROM_SERVER';
  constructor(
    public company: CompanyData,
    public serverIdentify: string,
    public registrationHistory: RegistrationHistory[],
    public invitation: Invitation
  ) {}
}

export class AddCompanyContract {
  readonly type = 'ADD_COMPANY_CONTRACT';
  constructor(public contractData: ContractData) {}
}

export class UpdateCompanyContractOnServer {
  readonly type = 'UPDATE_COMPANY_CONTRACT_ON_SERVER';
  constructor(public contractData: ContractData) {}
}

export class AddCompanyBeneficiaries {
  readonly type = 'ADD_COMPANY_BENEFICIARIES';
  constructor(public beneficiaries: Beneficiary[]) {}
}

export class UpdateCompanyBeneficiariesOnServer {
  readonly type = 'UPDATE_COMPANY_BENEFICIARIES_ON_SERVER';
  constructor(public beneficiaries: Beneficiary[]) {}
}

export class AddCompanyPix {
  readonly type = 'ADD_COMPANY_PIX';
  constructor(public pixs: Pix[]) {}
}

export class AddCompany {
  readonly type = 'ADD_COMPANY';
  constructor(public payload: CompanyData, public personType: PersonType) {}
}

export class AddAgent {
  readonly type = 'ADD_AGENT';
  constructor(public payload: AgentRegister) {}
}

export class CleanCompany {
  readonly type = 'CLEAN_COMPANY';
  constructor(public payload: CompanyData) {}
}

export class CompanyConfirmRegistration {
  readonly type = 'PERSON_CONFIRM_REGISTRATION';
  constructor(public confirmed: boolean) {}
}

export class UpdateCompany {
  readonly type = 'UPDATE_COMPANY';
  constructor(public company: CompanyData) {}
}

export class AddCompanyBankData {
  readonly type = 'ADD_BANK_DATA';
  constructor(public bankData: Array<BankData>) {}
}

export class AddPartners {
  readonly type = 'ADD_PARTNERS';
  constructor(public partner: Partner) {}
}

export class DeletePartners {
  readonly type = 'DELETE_PARTNERS';
  constructor(public index: number) {}
}

export class UpdatePartners {
  readonly type = 'UPDATE_PARTNERS';
  constructor(public partner: Partner, public index: number) {}
}

export class AddDirectors {
  readonly type = 'ADD_DIRECTORS';
  constructor(public director: Director) {}
}

export class DeleteDirectors {
  readonly type = 'DELETE_DIRECTORS';
  constructor(public index: number) {}
}

export class UpdateDirectors {
  readonly type = 'UPDATE_DIRECTORS';
  constructor(public director: Director, public index: number) {}
}

export class AddRelationship {
  readonly type = 'ADD_RELATIONSHIP';
  constructor(public contact: RelationshipContact) {}
}

export class UpdateCompanyPixOnServer {
  readonly type = 'UPDATE_COMPANY_PIX_ON_SERVER';
  constructor(public pixs: Pix[]) {}
}

export class UpdateRelationShipOnServer {
  readonly type = 'UPDATE_RELATIONSHIP_ON_SERVER';
  constructor(public agentId: string, public contacts: RelationshipContact[]) {}
}

export class DeleteRelationship {
  readonly type = 'DELETE_RELATIONSHIP';
  constructor(public index: number) {}
}

export class UpdateRelationship {
  readonly type = 'UPDATE_RELATIONSHIP';
  constructor(public contact: RelationshipContact, public index: number) {}
}

export class AddCompanyRegistrationHistory {
  readonly type = 'UPDATE_REGISTRATION_HISTORY_ON_SERVER';
  constructor(public history: RegistrationHistory) {}
}

export class AddCompanyRepresentative {
  readonly type = 'ADD_COMPANY_REPRESENTATIVE';
  constructor(public payload: Array<RepresentativesData>) {}
}

export class DeleteCompanyRepresentative {
  readonly type = 'DELETE_COMPANY_REPRESENTATIVE';
  constructor(public payload: RepresentativesData) {}
}

export class UpdateCompanyRepresentative {
  readonly type = 'UPDATE_COMPANY_REPRESENTATIVE';
  constructor(public payload: RepresentativesData) {}
}
export class AddCompanyFiles {
  readonly type = 'ADD_COMPANY_FILES';
  constructor(public files: Files[], public updateOnServer = true) {}
}

export class UpdateCompanyFiles {
  readonly type = 'UPDATE_COMPANY_FILES';
  constructor(public files: Files[]) {}
}

export class DisableCompanyFile {
  readonly type = 'DISABLE_COMPANY_FILES';
  constructor(public file: Files) {}
}
export class DisableCompanyFileOnServer {
  readonly type = 'DISABLE_COMPANY_FILES_ON_SERVER';
  constructor(public fileUrl: string) {}
}

export class AddCompanyEconomicGroup {
  readonly type = 'ADD_COMPANY_ECONOMIC_GROUP';
  constructor(public payload: EconomicGroup) {}
}

export class DeleteCompanyEconomicGroup {
  readonly type = 'DELETE_COMPANY_ECONOMIC_GROUP';
  constructor(public index: number) {}
}

export class AddCompanyAuthorizations {
  readonly type = 'ADD_COMPANY_AUTHORIZATIONS';
  constructor(public payload: Authorizations) {}
}

export class AddCompanySuitabilityQuestions {
  readonly type = 'ADD_COMPANY_SUITABILITY_QUESTIONS';
  constructor(public payload: Suitability) {}
}

export class AddCompanySuitabilityCompatibility {
  readonly type = 'ADD_COMPANY_SUITABILITY_COMPATIBILITY';
  constructor(public payload: Array<Question>) {}
}

export class AddCompanySuitabilityKnowledge {
  readonly type = 'ADD_COMPANY_SUITABILITY_KNOWLEDGE';
  constructor(public payload: Array<Question>) {}
}

export class AddCompanySuitabilityScore {
  readonly type = 'ADD_COMPANY_FINANCIAL_COMPATIBILITY';
  constructor(public suitabilityScore: SuitabilityScore) {}
}

export class AddCompanyOnServer {
  readonly type = 'ADD_COMPANY_ON_SERVER';
  constructor(public payload: CompanyData, public personType: PersonType) {}
}

export class UpdateCompanyRepresentativeOnServer {
  readonly type = 'UPDATE_COMPANY_REPRESENTATIVE_ON_SERVER';
  constructor(public payload: Array<RepresentativesData>) {}
}

export class UpdateCompanyBankDataOnServer {
  readonly type = 'UPDATE_COMPANY_BANK_DATA_ON_SERVER';
  constructor(public bankData: Array<BankData>) {}
}

export class UpdateCompanyFilesOnServer {
  readonly type = 'UPDATE_COMPANY_FILES_ON_SERVER';
  constructor(public files: Files[]) {}
}

export class UpdateCompanyEconomicGroupOnServer {
  readonly type = 'UPDATE_COMPANY_ECONOMIC_GROUP_ON_SERVER';
  constructor(public payload: EconomicGroup) {}
}

export class UpdateCompanyAuthorizationOnServer {
  readonly type = 'UPDATE_COMPANY_AUTHORIZATION_ON_SERVER';
  constructor(public payload: Authorizations) {}
}

export class UpdateCompanySuitabilityQuestionsOnServer {
  readonly type = 'UPDATE_COMPANY_SUITABILITY_QUESTIONS_ON_SERVER';
  constructor(public payload: Suitability) {}
}

export class UpdateCompanySuitabilityScoreOnServer {
  readonly type = 'UPDATE_COMPANY_FINANCIAL_COMPATIBILITY_ON_SERVER';
  constructor(public suitabilityScore: SuitabilityScore) {}
}
export class AddCompanyFiscalData {
  readonly type = 'ADD_FISCAL_DATA';
  constructor(public payload: any) {}
}
export class AddCompanyFiscalDataOnServer {
  readonly type = 'ADD_FISCAL_DATA_ON_SERVER';
  constructor(public payload: any) {}
}
export class AddCompanyPatrimonialDataOnServer {
  readonly type = 'ADD_PATRIMONIAL_DATA_ON_SERVER';
  constructor(public payload: PatrimonialSituation) {}
}

export class AddCompanySuitability {
  readonly type = 'ADD_COMPANY_SUITABILITY';
  constructor(public suitability: Suitability) {}
}

export class AddCompanySuitabilityFile {
  readonly type = 'ADD_COMPANY_SUITABILITY_FILE';
  constructor(
    public socialNumber: string,
    public virtualRawFingerprint: string
  ) {}
}

export class AddCompanyInvestorLevelFile {
  readonly type = 'ADD_COMPANY_INVESTOR_LEVEL_FILE';
  constructor(public socialNumber: string) {}
}

export class AddCompanyDispensedSuitability {
  readonly type = 'ADD_COMPANY_DISPENSED_SUITABILITY';
  constructor(public dispensedSuitability: boolean) {}
}

export type Actions =
  | AddCompany
  | AddCompanyRegistrationHistory
  | UpdateCompanyFiles
  | AddCompanyRepresentative
  | AddCompanyFiles
  | AddCompanyEconomicGroup
  | DeleteCompanyEconomicGroup
  | AddCompanyAuthorizations
  | AddCompanySuitabilityQuestions
  | AddCompanyOnServer
  | UpdateCompanyFilesOnServer
  | UpdateCompanyEconomicGroupOnServer
  | UpdateCompanyAuthorizationOnServer
  | UpdateCompanySuitabilityQuestionsOnServer
  | DisableCompanyFile
  | DisableCompanyFileOnServer
  | DeleteCompanyRepresentative
  | UpdateCompanyRepresentative
  | CleanCompany
  | AddCompanyFiscalData
  | AddCompanyFiscalDataOnServer
  | AddAgent
  | AddPartners
  | UpdatePartners
  | DeletePartners
  | AddCompanyPix
  | AddCompanyPatrimonialDataOnServer
  | AddCompanySuitability
  | AddCompanySuitabilityFile
  | AddCompanyPatrimonialDataOnServer
  | AddCompanyInvestorLevelFile
  | AddCompanyDispensedSuitability
  | AddCompanySuitabilityFile;
